import React from "react";
import MonetaryUtils from "../../../../shared/utils/MonetaryUtils";
import TooltipGeneric from "../../../../shared/components/generic/tooltip/tooltip-generic";

export const growthGoalsColumns = ({
	grossSalesIndexUsed
} = {}) => [
		{
			key: "growth",
			label: (
				<span className="growth-goals-columns__label-with-tooltip">
					Crescimento

					<TooltipGeneric
						content={
							"Crescimento acima da média de faturamento considerando uma baseline mínima de [média de faturamento net sales por mês]"
						}
						iconSize={14}
						placement="top"
					/>
				</span>
			),
		},
		{
			key: "netSales",
			label: "Net Sales",
			render: row => MonetaryUtils.formatCurrency(row.netSales)
		},
		{
			key: "grossSalesValue",
			label: (
				<span className="growth-goals-columns__label-with-tooltip">
					Estimativa Valor Bruto

					<TooltipGeneric
						content={
							grossSalesIndexUsed
								? `Valor obtido pelo cálculo +${grossSalesIndexUsed}% * NET SALES`
								: "Valor obtido pelo cálculo índice Gross Sales * NET SALES"
						}
						iconSize={14}
						placement="top"
					/>
				</span>
			),
			render: row => MonetaryUtils.formatCurrency(row.grossSalesValue)
		},
		{
			key: "originalInstallmentAmount",
			label: "Valor Original da Parcela",
			render: row => MonetaryUtils.formatCurrency(row.originalInstallmentAmount)
		},
		{
			key: "installmentDiscountPercentage",
			label: (
				<span className="growth-goals-columns__label-with-tooltip">
					% Desconto nas Parcelas

					<TooltipGeneric
						content={
							`Percentual de desconto é aplicado sobre a parcela de referência do programa, limitado ao valor original da parcela.
Parcela de referência = [Valor do equipamento] / [ Número total de parcelas – 3]`
						}
						iconSize={14}
						placement="top"
					/>
				</span>
			),
			render: row => `${row.installmentDiscountPercentage}%`
		},
		{
			key: "adjustedInstallmentValue",
			label: "Valor da Parcela Reajustado",
			render: row => MonetaryUtils.formatCurrency(row.adjustedInstallmentValue)
		},
		{
			key: "installmentDiscountValue",
			label: "Valor de Desconto na Parcela",
			render: row => MonetaryUtils.formatCurrency(row.installmentDiscountValue)
		},
		{
			key: "totalEquipmentDiscount",
			label: "Desconto Total do Equipamento",
			render: row => MonetaryUtils.formatCurrency(row.totalEquipmentDiscount)
		},
		{
			key: "adjustedEquipmentValue",
			label: "Valor do Equip. Reajustado",
			render: row => MonetaryUtils.formatCurrency(row.adjustedEquipmentValue)
		}
	];